import { Grid, Box } from '@material-ui/core';
import { PreviewPurchaseTransactionDataFragment } from '../../../api';
import { PurchaseOrSalesTransactionTabType } from '../../SaleTransactions';
import { PurchaseTransactionsItem } from '.';

export type PurchaseTransactionsBodyProps = {
    purchaseTransactions: PreviewPurchaseTransactionDataFragment[];
    currentTab?: PurchaseOrSalesTransactionTabType;
};

const PurchaseTransactionsBody = ({ purchaseTransactions, currentTab }: PurchaseTransactionsBodyProps) => (
    <Box mb={3} mt={3}>
        <Grid spacing={2} container>
            {purchaseTransactions.map(purchaseTransaction => (
                <PurchaseTransactionsItem
                    key={purchaseTransaction.id}
                    currentTab={currentTab}
                    purchaseTransaction={purchaseTransaction}
                />
            ))}
        </Grid>
    </Box>
);

export default PurchaseTransactionsBody;
